import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate, injectIntl, defineMessages } from 'react-intl';
import { Button } from 'reactstrap';

import VoucherWarningModal from 'Components/Order/VoucherWarningModal';
import { revealKey, revealMysteryKey } from 'Redux/ducks/orders';
import { toggleRedeemRequestModal } from 'Redux/ducks/modal';
import { setReturnMethod } from 'Redux/ducks/atok';
import store from 'Redux/store';

const messages = defineMessages({
  error: {
    id: 'reveal-key-button.error',
    defaultMessage: 'Your key for this title is temporarily unavailable, we apologise and are looking to rectify this as soon as possible.',
  },
});


function KeyRevealButton({
  game,
  bundleID,
  isCoupon,
  drm,
  orderID,
  intl,
  setName,
  setKey,
  freeOrder,
  isMysteryReveal,
  setMysteryRevealed,
  setMysteryGameDetails,
}) {
  const [inProgress, setInProgress] = useState(false);

  const Component = isCoupon && !freeOrder ? VoucherWarningModal : React.Fragment;

  const expireDate = game.serialExpiry ? new Date(game.serialExpiry) : '';
  const hasExpired = (expireDate !== '') && (new Date() > expireDate);
  const showReveal = !game.serialExpiry || !hasExpired;

  const click = async () => {
    if (inProgress) {
      return false;
    }

    setInProgress(true);
    const { key, productName, mysteryGameDetails } = await revealKey(orderID, bundleID, game);

    const giftbtn = document.getElementById('gift-button-trigger');

    if (giftbtn) {
      giftbtn.remove();
    }


    if (key === 'error') {
      alert(intl.formatMessage(messages.error)); // eslint-disable-line no-alert
      setInProgress(false);
      return false;
    }


    if (key === 'email') {
      setReturnMethod(click);
      store.dispatch(toggleRedeemRequestModal());
      return setInProgress(false);
    }


    if (productName) {
      setName(productName);
    }

    setKey(key);

    if (mysteryGameDetails) {
      setMysteryGameDetails(mysteryGameDetails);
    }

    return true;
  };

  const clickMystery = async () => {
    if (inProgress) {
      return false;
    }

    setInProgress(true);

    const {
      mysteryGameDetails,
      productName,
      message,
    } = await revealMysteryKey(orderID, bundleID, game);

    if (message) {
      alert(message); // eslint-disable-line no-alert
      setInProgress(false);
      return false;
    }

    if (productName) {
      setName(productName);
      setMysteryRevealed(true);
      setInProgress(false);
    }

    if (mysteryGameDetails) {
      setMysteryGameDetails(mysteryGameDetails);
    }

    return true;
  };

  return (
    <Component>
      {isMysteryReveal &&
        <Button block color="primary" disabled={inProgress} onClick={clickMystery}>
          <FormattedMessage id="reveal-key-button.reveal-mystery" defaultMessage="Reveal Mystery Game" />
        </Button>
      }
      {showReveal && !isMysteryReveal &&
        <Button block color="primary" disabled={inProgress} onClick={click}>
          {drm === 'redeem' && !isCoupon &&
            <FormattedMessage id="reveal-key-button.reveal-redeem" defaultMessage="Reveal Redeem Code" />
          }
          {drm !== 'redeem' && !isCoupon &&
            <React.Fragment>
              {game.display_type === 'gift-card' ?
                <FormattedMessage id="reveal-key-button.reveal-giftcardcode" defaultMessage="Reveal Gift Card Code" />
                :
                <FormattedMessage id="reveal-key-button.reveal-key" defaultMessage="Reveal Key" />
              }
            </React.Fragment>
          }
          {isCoupon &&
            <FormattedMessage id="reveal-key-button.reveal-coupon" defaultMessage="Reveal Coupon" />
          }
        </Button>
      }
      {game.serialExpiry && hasExpired &&
        <div className="key-expire-text">
          <FormattedMessage
            id="reveal-key-button.expiredMessage"
            defaultMessage="This Key Has Expired"
          />
        </div>
      }
      {game.serialExpiry && !hasExpired &&
        <div className="key-expire-text">
          <FormattedMessage
            id="reveal-key-button.expiresMessage"
            defaultMessage="This Key Expires On"
          />
          &nbsp;
          <FormattedDate
            value={expireDate}
            year="numeric"
            month="long"
            day="2-digit"
            hour="2-digit"
            minute="2-digit"
            timeZone="UTC"
          />&nbsp;(UTC)
        </div>
      }
    </Component>
  );
}

KeyRevealButton.propTypes = {
  game: PropTypes.shape({}).isRequired,
  bundleID: PropTypes.string,
  drm: PropTypes.string,
  orderID: PropTypes.string.isRequired,
  isCoupon: PropTypes.bool,
  setName: PropTypes.func.isRequired,
  setKey: PropTypes.func.isRequired,
  freeOrder: PropTypes.bool,
  isMysteryReveal: PropTypes.bool,
};

KeyRevealButton.defaultProps = {
  bundleID: null,
  drm: null,
  isCoupon: false,
  freeOrder: false,
  isMysteryReveal: false,
};

export default injectIntl(KeyRevealButton);
